import { gql } from "@apollo/client";
import FormDialog from "controls/FormDialog";
import { useActionFragment } from "hooks/useAction";
import useData from "hooks/useData";
import { Plus } from "mdi-material-ui";
import React from "react";
import AdAssetForm from "readmin_pages/ad_assets/Form";

// registered as a batch dialog so it sits after Edit, but an upload only goes into one ad group
UploadAdAssetDialog.useButtonProps = ({ adPresetIds }) => {
  return {
    icon: <Plus />,
    content: "Upload Asset",
    hidden: adPresetIds?.length !== 1,
  };
};

export default function UploadAdAssetDialog({ adPresetIds, onSubmit, onClose }) {
  const [data, dataMeta] = useData(
    gql`
      query UploadAdAssetDialog($adPresetIds: [ID!]!) {
        adPresets(ids: $adPresetIds) {
          id
          name
          org {
            id
          }
        }
      }
    `,
    { adPresetIds },
  );
  const adPreset = data?.adPresets?.[0];

  const addAdAsset = useActionFragment("addAdAsset", "adAsset { id }");

  return (
    <FormDialog
      header={adPreset ? `Upload Asset to ${adPreset.name}` : "Upload Asset"}
      loading={dataMeta.loading}
      onClose={onClose}
      onSubmit={async (formData) => {
        await addAdAsset({
          input: {
            ...formData,
            // the org field is locked to the ad group's, and locked fields are left out of the form data
            org: { id: adPreset.org.id, typename: "Org" },
            adPresets: [{ id: adPreset.id, typename: "AdPreset" }],
          },
        });
        // stay on the ad group rather than following the new asset
        await onSubmit?.();
      }}
    >
      {adPreset && <AdAssetForm adAsset={{ org: { ...adPreset.org, __typename: "Org" } }} lockOrg />}
    </FormDialog>
  );
}
